import * as common from './common';

const defaultValue = 10;
const updateGiftcardValue = function () {
  const giftcardId = $(this).data('giftcard-id');
  const value = $(this).val();
  if ( value !== 'custom') {
    $(`#price_${giftcardId}`).html( value );
    $("#giftcard-price").html( common.formatPrice( value ) );
  } else {
    $(this).empty();
    $(`#price_${giftcardId}`).html(defaultValue);
    $("#giftcard-price").html(common.formatPrice(defaultValue));
    $('#giftcard-big-preview-price').html(defaultValue);
    const txt = `<input type="text" name="giftcard_${giftcardId}" value="${defaultValue}" class="giftcards_value" 
id="giftcards_default_select_${giftcardId}" data-giftcard-id="${giftcardId}" maxlength="3"> €`;
    $(`#giftcards_value_container_${giftcardId}`).html(txt);
  }
};
const addGiftcardForm = function () {
  let counter = $(this).data('counter');
  const oldVal = counter;
  counter = (counter * 1) + 1;
  let newGiftcardRow = `${$('.giftcard-box:last').get(0).outerHTML}`;
  newGiftcardRow = newGiftcardRow.split(`_${oldVal}`).join(`_${counter}`);
  newGiftcardRow = newGiftcardRow.split(`data-giftcard-id="${oldVal}"`).join(`data-giftcard-id="${counter}"`);
  $('.giftcard-box:last').after(newGiftcardRow);
  $(`#price_${counter}`).html(defaultValue);
  $(this).attr('data-counter', counter);
  if (counter === 9) {
    $('#add_giftcard').remove();
  }
};
const updateGiftcardPreviewContent = function (giftcardId) {
  const value = $(`#giftcards_default_select_${giftcardId}`).val();
  const fromName = $(`#from_${giftcardId}`).val();
  const toName = $(`#to_${giftcardId}`).val();
  const message = $(`#message_${giftcardId}`).val();

  if (fromName === '') {
    $('.giftcard-big-preview-message-from').hide();
  }

  if (toName === '') {
    $('.giftcard-big-preview-message-to').hide();
  }
  $('#giftcard-big-preview-price').html(value);

  if (fromName === '') {
    $('#from-line').hide();
  } else {
    $('#from-line').show();
    $('#from-name').html(fromName);
  }

  if (toName === '') {
    $('#to-line').hide();
  } else {
    $('#to-line').show();
    $('#to-name').html(toName);
  }
  $('#message-preview').html(message);
};

const showGiftcardPreview = function () {
  const giftcardId = $(this).data('giftcard-id');
  updateGiftcardPreviewContent(giftcardId);
  $.featherlight('#giftcard-big-preview');
};
$('#giftcards-page').on('load', '.giftcards-dropdown', updateGiftcardValue);
$('#giftcards-page').on('change', '.giftcards-dropdown', updateGiftcardValue);
$('.js-add-giftcard').click(addGiftcardForm);

$('#giftcards-page').on('keyup', '.giftcards_value', () => {
  const giftcardId = $(this).data('giftcard-id');
  $(`#price_${giftcardId}`).html($(this).val());
  $('#giftcard-big-preview-price').html($(this).val());
});
$('#giftcards-page').on('click', '.see-preview', showGiftcardPreview);

